const lightColor = getComputedStyle(document.documentElement).getPropertyValue('--light-color').trim();

export const defaultHybridMapPolygonOptions: google.maps.PolygonOptions = {
  strokeColor: lightColor,
  fillColor: lightColor,
};
